module.exports = __webpack_public_path__ + "static/media/ic_send_email.ec31a3b4.svg";